import gql from 'graphql-tag'

export const query = gql`
  query findExpenseCategory($filter: settings_expense_category_bool_exp!,$order: [settings_expense_category_order_by!], $limit: Int){
    records: settings_expense_category(where: $filter,order_by: $order, limit: $limit) {
      id
      name
      description
    }
  }
`

export default query
